import React, { createContext, useState, useCallback, useRef, useEffect } from 'react';

export const ToastContext = createContext();

const TOAST_DURATION_MS = 2500;

export const ToastProvider = ({ children }) => {
  const [message, setMessage] = useState('');
  const [open, setOpen] = useState(false);
  const timeoutRef = useRef(null);

  const showToast = useCallback((msg) => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = null;
    }
    setMessage(msg);
    setOpen(true);
    timeoutRef.current = setTimeout(() => {
      setOpen(false);
      setMessage('');
      timeoutRef.current = null;
    }, TOAST_DURATION_MS);
  }, []);

  useEffect(() => {
    return () => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
    };
  }, []);

  return (
    <ToastContext.Provider value={{ showToast }}>
      {children}
      {open && message && (
        <div
          className="fixed left-1/2 bottom-6 z-[9999] -translate-x-1/2 px-4 py-3 bg-gray-900 dark:bg-gray-800 text-white text-sm font-medium rounded-lg shadow-lg"
          role="status"
          aria-live="polite"
        >
          {message}
        </div>
      )}
    </ToastContext.Provider>
  );
};

export const useToast = () => {
  const context = React.useContext(ToastContext);
  if (!context) {
    throw new Error('useToast must be used within ToastProvider');
  }
  return context;
};
